export interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  /** Accessible name, for example "Offer New patient visit". */
  label: string
  disabled?: boolean
}

/** An on/off switch (`role="switch"`). */
export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="toggle"
      disabled={disabled}
      onClick={() => {
        onChange(!checked)
      }}
    />
  )
}
